import { MutationOptions } from "@apollo/client";
import gql from "graphql-tag";
import { GraphQlMutationBuilder } from "../graphQL-mutation.builder";

export interface PermisoDashboardDeleted {
    uuidDashboard: string;
}

export class UnsubscribeDashboardBuilder {
    private _DASHBOARDUUID: string;

    private get _mutation() {
        return gql`mutation unsubscribeFromDashboard($uuidDashboard: String) {
            unsubscribeFromDashboard(uuidDashboard: $uuidDashboard)
          }`;
    }

    public withDashboardUUID(dashboardUUID: string): this {
        this._DASHBOARDUUID = dashboardUUID;
        return this;
    }

    public build(): MutationOptions {
        const mutationParams: PermisoDashboardDeleted  = { uuidDashboard: this._DASHBOARDUUID };
        const graphQlMutationBuilder: GraphQlMutationBuilder = new GraphQlMutationBuilder();
        return graphQlMutationBuilder.withMutation(this._mutation)
        .withParams(mutationParams)
        .build();
    }
}
